export enum EnvironmentEnum {
  Demo = 'Demo',
  Dev = 'Dev',
  DR = 'DR',
  Local = 'Local',
  Prod = 'Prod',
  Staging = 'Staging',
  Test = 'Test',
  Automation = 'Automation',
}

export enum EnvironmentDomain {
  Demo = 'demo',
  Dev = 'dev',
  DR = 'dr',
  Prod = 'prod',
  Staging = 'staging',
  Test = 'test',
}
